/* MediaTech — JS principale del tema */
(function () {
  function initReveals(scope) {
    var els = (scope || document).querySelectorAll('[data-mt-reveal]:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  window.MediaTech = window.MediaTech || {};
  window.MediaTech.initReveals = initReveals;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveals(); });
  } else {
    initReveals();
  }
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); });
})();
